/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ItemTileBase_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"Shipping_viewer">;
    readonly " $refType": "ItemTileBase_viewer";
};
export type ItemTileBase_viewer$data = ItemTileBase_viewer;
export type ItemTileBase_viewer$key = {
    readonly " $data"?: ItemTileBase_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileBase_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Shipping_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '3a2dc2c77f4d0f70ab043a085994c1de';
export default node;
